import { getBuyButtonConfig } from '../utils/commonEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const ADP_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.adp.buyBox.bulletPoint1' },
          { title: 'productPage.adp.buyBox.bulletPoint2' },
          { title: 'productPage.adp.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.adp.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.adp.buyBox.veloCta.prompt',
          topic: 'adp-small-business',
        },
        interactService: {
          ctaType: 'adpReferral',
          service: 'adp_referral',
        },
        note: 'productPage.adp.buyBox.note',
        noteLink: {
          text: 'productPage.adp.buyBox.noteLink',
          url: 'https://subscribe.adpinfo.com/',
        },
        termsLink: {
          message: 'productPage.adp.buyBox.termsLink',
          url: '#footnotes',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/cafe-remote-working.png',
      alt: 'productPage.adp.heroHeaderPicture.altText',
    },
    headline: 'productPage.adp.page.headline',
    partnerLogo: {
      src: '/s2/raster/partner-adp-logo.png',
      alt: 'productPage.adp.heroPartnerLogo.altText',
    },
    partnerReviewBlanks: [],
    subheader: 'productPage.adp.page.subheader',
  },
  benefit: {
    title: 'productPage.adp.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/groupsrounded.svg',
        title: 'productPage.adp.valueProp.propTitle1',
        description: 'productPage.adp.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/calculaterounded.svg',
        title: 'productPage.adp.valueProp.propTitle2',
        description: 'productPage.adp.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.adp.valueProp.propTitle3',
        description: 'productPage.adp.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.adp.howItWorks.title',
    items: [
      {
        title: 'productPage.adp.howItWorks.step1',
        description: 'productPage.adp.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.adp.howItWorks.step2',
        description: 'productPage.adp.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.adp.howItWorks.step3',
        description: 'productPage.adp.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.adp.howItWorks.step4',
        description: 'productPage.adp.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/baker-cafe-laptop-watch.png',
    alt: 'productPage.adp.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  whatsIncluded: {
    title: 'productPage.adp.whatsIncluded.title',
    items: [
      {
        title: 'productPage.adp.whatsIncluded.item1',
        description: 'productPage.adp.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.adp.whatsIncluded.item2',
        description: 'productPage.adp.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.adp.whatsIncluded.item3',
        description: 'productPage.adp.whatsIncluded.item3ShortDescription',
      },
    ],
    disclaimers: ['productPage.adp.whatsIncluded.disclaimer1', 'productPage.adp.whatsIncluded.disclaimer2'],
    image: '/s2/raster/carpenter-phone-smiling.png',
    alt: 'productPage.adp.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  footnotes: {
    divider: false,
    items: [
      {
        text: 'productPage.adp.footnotes.disclaimer1',
      },
      {
        text: 'productPage.adp.footnotes.disclaimer2',
      },
    ],
  },
  assistance: {
    title: 'productPage.adp.needAssistance.title',
    getInTouch: 'productPage.adp.needAssistance.getInTouch',
    actions: 'productPage.adp.needAssistance.actions',
  },
  getBuyButtonConfig: (
    entitlements,
    service,
    _domesticJurisdiction,
    _formedBy,
    _formationStatus,
    ctaConfigContext = {},
  ) => {
    const { adpReferralSubmitted = false } = ctaConfigContext;

    const baseConfig = getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.adp.buyBox.buttonLabel.notSubmitted',
    });

    if (adpReferralSubmitted) {
      return {
        ...baseConfig,
        ctaDisabledTooltip: null,
        ctaText: 'productPage.adp.buyBox.buttonLabel.submitted',
        isBuyEnabled: false,
      };
    }

    return baseConfig;
  },
};
